import { render, staticRenderFns } from "./AddAdultProcess.vue?vue&type=template&id=7e2968b6&scoped=true&lang=pug"
import script from "./AddAdultProcess.vue?vue&type=script&lang=js"
export * from "./AddAdultProcess.vue?vue&type=script&lang=js"
import style0 from "./AddAdultProcess.vue?vue&type=style&index=0&id=7e2968b6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2968b6",
  null
  
)

export default component.exports